import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import usePageSearchHistory from '@/hooks/pageSearchHistory';
import { Button, Divider } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  customerId: number;
  disabled?: boolean;
}

const CustomerFooter: React.FC<Props> = ({ disabled }) => {
  const history = useHistory();

  const { getSearch } = usePageSearchHistory();
  const path = '/app/customers/list';
  const pathWithSearch = path + getSearch(path);

  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack path={pathWithSearch} disabled={disabled} />

        <Button
          block
          type="primary"
          onClick={() => history.push(`/app/customers/create`)}
        >
          Novo Cliente
        </Button>
      </SpaceForButton>
    </>
  );
};

export default CustomerFooter;
